module.exports = __webpack_public_path__ + "img/windows-server-2019.eb8b598c.svg";